export const TORRENT_API =
    process.env.GATSBY_API_URL || "https://download.dapp.zap-torrent.com";
